<template>
  <el-container id="tab">
    <el-aside :width="isCollapse ? '20px' : '230px'">
      <el-card v-show="!isCollapse" class="box-card">
        <div slot="header">
          <span>录入条件</span>
          <el-button style="float: right; padding: 3px 0" icon="el-icon-d-arrow-left" type="text" @click="isCollapse = !isCollapse"></el-button>
        </div>
        <el-form ref="queryFormRef" :model="queryForm" size="small">
          <el-scrollbar>
            <el-form-item label="客户" prop="customer.selected">
              <select-multiple class="query_form_item" :select-data="queryForm.customer" :change="() => { multipleChange('salesman') }" :isClear="false" isTable :column-list="selectMultipleTableColumnListCommon.customer"></select-multiple>
            </el-form-item>
            <el-form-item label="出库库房" prop="inWarehouse.selected">
              <select-multiple ref="inWarehouse" class="query_form_item" :select-data="queryForm.inWarehouse" suffixText="盘点中" :isClear="false" :change="() => { multipleChange('salesman') }"></select-multiple>
            </el-form-item>
            <el-form-item label="费用类型" prop="type.selected">
              <select-multiple class="query_form_item" ref="type" :select-data="queryForm.type" :isClear="false" :change="() => { multipleChange('type') }"></select-multiple>
            </el-form-item>
            <el-form-item label="经手人" prop="salesman.selected">
              <select-multiple class="query_form_item" ref="salesman" :select-data="queryForm.salesman" :isClear="false" :change="() => { multipleChange('salesman') }"></select-multiple>
            </el-form-item>
            <el-form-item label="日期" prop="billDate.selected">
              <date-picker style="width: 100%;" v-model="queryForm.billDate.selected" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :value-format="'yyyy-MM-dd'" :picker-options="pickerOptions">
              </date-picker>
            </el-form-item>
            <el-form-item prop="isUsePrice.selected" style="text-align: center;">
              <el-checkbox v-model="queryForm.isUsePrice.selected" true-label="Y" false-label="N" @change="isUsePriceChange">使用成本价</el-checkbox>
            </el-form-item>
            <el-form-item label="费用金额" prop="payAmt.selected">
              <el-input-number v-model="queryForm.payAmt.selected" :precision="2" :min="0" :controls="false" style="width: 100%;" :disabled="queryForm.isUsePrice.selected == 'Y'"></el-input-number>
            </el-form-item>
            <el-form-item label="备注" prop="remark.selected">
              <el-input v-model="queryForm.remark.selected" ref="remark" type="textarea" :autosize="{ minRows: 2 }" clearable placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-scrollbar>
        </el-form>
      </el-card>
      <div class="is-collapse" v-show="isCollapse" @click="isCollapse = !isCollapse">
        <span style="text-align: center;">录入</span>
        <el-button icon="el-icon-d-arrow-right" type="text"></el-button>
        <span style="text-align: center;">条件</span>
      </div>
    </el-aside>
    <el-main>
      <el-card class="box-card">
        <div slot="header">
          <span>货物</span>
        </div>
        <div class="table">
          <ux-grid ref="uxGrid" size="mini" :data="tableList" :height="uxGridHeight" max-height="100%" border stripe :highlightCurrentRow="false" :edit-config="{trigger: 'click', mode: 'cell'}" show-overflow="title" @edit-actived="editActived">
            <ux-table-column type="index" width="50" title="序号" resizable fixed="left"></ux-table-column>
            <ux-table-column width="60" title="操作" resizable fixed="left">
              <template v-slot="{ row, rowIndex }">
                <el-button icon="el-icon-plus" type="text" :style="rowIndex + 1 == tableList.length ? 'color: red' : ''" @click="addRow(rowIndex + 1)"></el-button>
                <el-button icon="el-icon-delete" type="text" style="margin: 0;" @click="deleteRow(row)"></el-button>
              </template>
            </ux-table-column>
            <ux-table-column field="itemName" title="商品" width="180" edit-render resizable fixed="left">
              <template v-slot:edit="{ row, rowIndex }">
                <select-byProduct :parameter="{ warehouseID: queryForm.inWarehouse.selected.value, customerID: queryForm.customer.selected.value, billType: 'FYD' }" :placeholder="row.itemName" @select="selectProductData($event, row, rowIndex)"></select-byProduct>
              </template>
              <template v-slot="{ row }">{{ row['itemName'] }}</template>
            </ux-table-column>
            <ux-table-column field="itemSpec" title="商品规格" width="100" resizable></ux-table-column>
            <ux-table-column field="availableQtyFormat" title="可用库存" width="100" resizable></ux-table-column>
            <ux-table-column field="productionDate" title="生产日期" width="100" resizable></ux-table-column>
            <ux-table-column title="数量" header-align="center" resizable>
              <ux-table-column field="salUnitQty" title="大单位数量" width="100" edit-render resizable>
                <template v-slot:edit="{ row }">
                  <el-input-number v-if="row.salUnitName" v-model="row.salUnitQty" :precision="2" :min="0" v-focus :controls="false" style="width: 100%;" @change="inputNumber"></el-input-number>
                  <span v-else>
                    <span v-if="row.itemName">--</span>
                  </span>
                </template>
                <template v-slot="{ row }">
                  <span v-if="row.salUnitName">{{ row['salUnitQty'] }}</span>
                  <span v-else>
                    <span v-if="row.itemName">--</span>
                  </span>
                  <span v-if="Number(row['salUnitQty'])">{{ '/' + row['salUnitName'] }}</span>
                </template>
              </ux-table-column>
              <ux-table-column field="midUnitQty" title="中单位数量" width="100" edit-render resizable>
                <template v-slot:edit="{ row }">
                  <el-input-number v-if="row.midUnitName" v-model="row.midUnitQty" :precision="2" :min="0" v-focus :controls="false" style="width: 100%;" @change="inputNumber"></el-input-number>
                  <span v-else>
                    <span v-if="row.itemName">--</span>
                  </span>
                </template>
                <template v-slot="{ row }">
                  <span v-if="row.midUnitName">{{ row['midUnitQty'] }}</span>
                  <span v-else>
                    <span v-if="row.itemName">--</span>
                  </span>
                  <span v-if="Number(row['midUnitQty'])">{{ '/' + row['midUnitName'] }}</span>
                </template>
              </ux-table-column>
              <ux-table-column field="invUnitQty" title="小单位数量" width="100" edit-render resizable>
                <template v-slot:edit="{ row }">
                  <el-input-number v-if="row.salUnitConversion != 1 && row.invUnitName" v-model="row.invUnitQty" :precision="2" :min="0" v-focus :controls="false" style="width: 100%;" @change="inputNumber"></el-input-number>
                </template>
                <template v-slot="{ row }">
                  <span>{{ row['invUnitQty'] }}</span>
                  <span v-if="Number(row['invUnitQty'])">{{ '/' + row['invUnitName'] }}</span>
                </template>
              </ux-table-column>
            </ux-table-column>
            <ux-table-column field="remark" title="备注" width="100" edit-render resizable>
              <template v-slot:edit="{ row }">
               <el-input v-if="row.itemName" v-model="row['remark']" v-focus></el-input>
              </template>
              <template v-slot="{ row }">
                <span>{{ row['remark'] }}</span>
              </template>
            </ux-table-column>
            <ux-table-column field="flavorDesc" title="多口味" width="100" edit-render resizable>
              <template v-slot:edit="{ row }">
                <el-select v-if="row.flavorList" v-model="row.flavor" placeholder="请选择多口味" value-key="flavorID" v-focus automatic-dropdown>
                  <el-option
                    v-for="item in row.flavorList"
                    :key="item.flavorID"
                    :label="item.flavorDesc"
                    :value="item">
                  </el-option>
                </el-select>
              </template>
              <template v-slot="{ row }">
                <span v-if="row.flavor && row.flavor.flavorID">{{ row.flavor.flavorDesc }}</span>
              </template>
            </ux-table-column>
            <ux-table-column field="invBarCode" title="条码" width="120" resizable>
              <template v-slot="{ row }">
                  <div v-if="row.salBarCode">
                    <span>{{ row.salBarCode }}</span><span>/大</span>
                  </div>
                  <div v-if="row.midBarCode">
                    <span>{{ row.midBarCode }}</span><span>/中</span>
                  </div>
                  <div v-if="row.invBarCode">
                    <span>{{ row.invBarCode }}</span><span>/小</span>
                  </div>
              </template>
            </ux-table-column>
          </ux-grid>
        </div>
        <div class="footer">
          <span>共<span class="text">{{sum.total}}</span>条,<span class="text">{{sum.amount.sal}}</span>大<span class="text">{{sum.amount.mid}}</span>中<span class="text">{{sum.amount.inv}}</span>小</span>
          <div>
            <el-button size="medium" @click="onSubmit(true)">保存草稿</el-button>
            <el-button size="medium" @click="onSubmit(false)">支付</el-button>
          </div>
        </div>
      </el-card>
    </el-main>
  </el-container>
</template>

<script>
import datePicker from '@/components/common/datePicker.vue'
import selectByProduct from '@/components/common/selectByProduct.vue'
import { toRawType, pickerOptions, getAddDate, getNowFormatDate, toFixedRe } from '@/assets/js/common.js'
export default {
  name: "CustomerGoodsFeeForm",
  components: {
    datePicker,
    selectByProduct
  },
  mixins: [selectMultipleTableColumnListCommonMixins],
  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector('input').onfocus = function (e) {
          e.currentTarget.select()
        }
        el.querySelector('input').focus()
      }
    }
  },
  data() {
    let beginDate = getAddDate(-3)
    let endDate = getNowFormatDate()
    return {
      isCollapse: false,
      queryForm: {
        customer: { submitName: 'customer', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户', request: { url: '/Account/customerDefine/getCustomerListForVue.html', type: 'post', params: {page: 1, size: 5}, text: '', value: '' }},
        salesman: { submitName: 'hand', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择经手人', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
        type: { submitName: 'type', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择费用类型', request: { url: '/Account/dataSearchVue/getFeeTypeList.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
        inWarehouse: { submitName: "warehouse", selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, isDisabled: false, list: [], placeholder: "请选择出库库房", request: { url: "/Account/wareHouseDefine/selectWarehouseFreezeForAuth.html", type: "post", params: { page: 1, size: 5 }, text: "", value: "", } },
        isUsePrice: { submitName: 'isUsePrice', selected: 'N' },
        payAmt: { submitName: 'payAmt', selected: '' },
        remark: { submitName: 'remark', selected: '' },
        billDate: { submitName: 'billDate', selected: [beginDate, endDate] },
      },
      pickerOptions: pickerOptions,
      tableList: this.pushItem(),
      params: {
        payType: 'B'
      },
      uxGridHeight: 360,
      sum: {
        total: 0,
        amount: {
          sal: 0,
          mid: 0,
          inv: 0
        }
      },
    }
  },
  watch: {
    tableList() {
      this.updateSum()
    }
  },
  computed: {
    queryItem () {
      let tempItem = {}
      Object.values(this.queryForm).forEach(item => {
        if (item.submitName == 'billDate') {
          tempItem['startDate'] = item.selected[0]
          tempItem['endDate'] = item.selected[1]
        } else if (item.submitName == 'hand') {
          tempItem[item.submitName + 'Id'] = item.selected.value
          tempItem[item.submitName + 'Name'] = item.selected.text
        } else {
          if (toRawType(item.selected) == 'Object') {
            tempItem[item.submitName + 'ID'] = item.selected.value
            tempItem[item.submitName + 'Name'] = item.selected.text
          } else {
            tempItem[item.submitName] = item.selected
          }
        }
      })
      return tempItem
    }
  },
  mounted () {
    this.uxGridHeight = parseInt($('.table').css('height'))
    window.onresize = () => {
      this.uxGridHeight = parseInt($('.table').css('height'))
    }
  },
  methods: {
    pushItem (length = 20) {
      const tempItem = []
      for (let i = 0; i < length; i++) {
        tempItem.push({})
      }
      return tempItem
    },
    updateSum() {
      let total = 0, sal = 0, mid = 0, inv = 0
      this.tableList.forEach((item, index) => {
        item['lineNum'] = index + 1
        if (item.itemID) {
          total += 1
          sal += Number(item['salUnitQty'] || 0)
          mid += Number(item['midUnitQty'] || 0)
          inv += Number(item['invUnitQty'] || 0)
        }
      })
      this.sum.total = total
      this.sum.amount.sal = Number(toFixedRe(sal, 2))
      this.sum.amount.mid = Number(toFixedRe(mid, 2))
      this.sum.amount.inv = Number(toFixedRe(inv, 2))
    },
    async multipleChange() {
      if (this.tableList.filter(i => i.itemID).length == 0) return false
      const confirmResult = await this.$confirm('您已录入商品，此操作将删除所有商品, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') return this.$message.info('取消')
      this.tableList = this.pushItem()
    },
    selectProductData(data, row, index) {
      let type = toRawType(data)
      if (type == 'Array') {
        if (data.length) {
          data.forEach(($item) => {
            try {
              this.tableList.forEach((item, i) => {
                if (i >= index && !item.itemID) {
                  this.$set(this.tableList, i, { ...item, ...$item })
                  throw item
                }
              })
            } catch (e) {
              
            }
          })
        }
      } else {
        this.$set(this.tableList, index, { ...row, ...data })
      }
    },
    addRow (index) {
      if (index === this.tableList.length) {
        this.tableList = this.tableList.concat(this.pushItem(10))
      } else {
        this.tableList.splice(index, 0, {})
      }
    },
    async deleteRow ({ rowIndex: $index, row }) {
      if (this.tableList.length <= 1) return
      const confirmResult = await this.$confirm('此操作为删除操作, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') return this.$message.info('取消删除')
      this.$nextTick(() => {
        this.tableList.splice($index, 1)
      })
    },
    checkSubmit() {
      if (!this.queryForm.customer.selected.value) {
        this.$message({
          showClose: true,
          message: '请先选择客户',
          type: 'warning'
        })
        return false
      }
      if (!this.queryForm.inWarehouse.selected.value) {
        this.$message({
          showClose: true,
          message: '请先选择出库库房',
          type: 'warning'
        })
        return false
      }
      if (!this.queryForm.type.selected.value) {
        this.$message({
          showClose: true,
          message: '请先选择费用类型',
          type: 'warning'
        })
        return false
      }
      if (!this.queryForm.salesman.selected.value) {
        this.$message({
          showClose: true,
          message: '请先选择经手人',
          type: 'warning'
        })
        return false
      }
      return true
    },
    editActived({ column }) {
      if (column.property == 'itemName') {
        if (!this.checkSubmit()) {
          this.$refs.uxGrid.clearActived()
        }
      }
    },
    inputNumber() {
      this.updateSum()
    },
    isUsePriceChange(val) {
      if (val == 'Y') {
        this.queryForm.payAmt.selected = 0
      }
    },
    onSubmit(isDraft = false) {
      let tabData = this.tableList.filter(i => {
        if (i.itemID) {
          // i.salBillPrice = i.salCostPrice
          // i.midBillPrice = i.midCostPrice
          // i.billPrice = i.invCostPrice
          return true
        }
      })
      if (tabData.length == 0) {
        this.$message({
          showClose: true,
          message: '请先选择商品',
          type: 'error'
        })
        return false
      }
      let flag = tabData.some(item => {
        const { itemID, salUnitQty, midUnitQty, invUnitQty, lineNum } = item
        if (itemID && !Number(salUnitQty) && !Number(midUnitQty) && !Number(invUnitQty)) {
          this.$message({
              showClose: true,
              message: '第' + lineNum + '行,商品数量不能为零',
              type: 'error'
          })
          return true
        } else {
          return false
        }
      })
      if (flag) return false
      let url = ''
      if (isDraft) {
        url = '/Account/feebillReviewVue/customerReviewFeeVue/addFeeBillReviewVue.html'
      } else {
        url = '/Account/feebillVue/customerFeeVue/addFeeBillVue.html'
      }
      let params = { ...this.params, ...this.queryItem }
      if (params.isUsePrice == 'N' && toRawType(params.payAmt) != 'Number') {
        this.$message({
          showClose: true,
          message: '请输入正确的费用金额',
          type: 'error'
        })
        return false
      }
      const loading = this.$loading({
        lock: true,
        text: '提交中,请等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      if (this.checkSubmit()) {
        let currTab = ''
        if (top.$('#tabspanel .tabs-selected').text()) {
          currTab = top.$('#tabspanel').tabs('getSelected') || ''
        } else {
          currTab = top.getTabName()
        }
        params.detailList = JSON.stringify(tabData)
        this.$http.post(url, this.Qs.stringify(params)).then(({ data: res }) => {
          loading.close()
          if (res.code != 0) {
            return this.$message.error(res.message)
          } else {
            this.$message.success(res.data)
            if (!isDraft) {
              setTimeout(() => {
                top.refreshTabWithUrl(`/templates/vue-account/dist/index.htm#/CustomerGoodsFeeForm`, currTab)
              }, 1500)
            }
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
#tab {
  height: calc(100vh - 20px);
  .box-card {
    display: flex;
    flex-flow: column;
    height: calc(100% - 2px);
    ::v-deep .el-card__header {
      padding: 8px 20px;
      height: 33px;
      background-color: #F5F7FA;
      color: #409EFF;
    }
    ::v-deep .el-card__body {
      padding: 6px;
      flex: 1;
      box-sizing: border-box;
    }
  }
  .el-aside {
    ::v-deep .el-card__body {
      .el-form {
        height: 100%;
        .el-scrollbar {
          height: 100%;
        }
        .el-form-item {
          margin: 18px 0 0;
          position: relative;
          .el-form-item__label {
            position: absolute;
            z-index: 2;
            top: -12px;
            margin-left: 10px;
            padding: 0 6px;
            line-height: normal;
            background-color: #fff;
          }
          .amt-info {
            border: 1px #F56C6C solid;
            color: #F56C6C;
            span {
              display: block;
              text-align: center;
            }
          }
        }
      }
      .calculation-form {
        .el-form-item {
          text-align: center;
          .el-form-item__label {
            margin: 0;
            left: 36px;
          }
          .input-with-select {
            .el-input-group__prepend {
              padding: 0 12px;
              background-color: #fff;
              .select-multiple {
                display: inline-block;
                width: 50px;
              }
            }
          }
          .el-input-number .el-input__inner {
            text-align: left;
          }
        }
      }
    }
    .is-collapse {
      width: calc(100% - 2px);
      height: calc(100% - 2px);
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      border: 1px #DCDFE6 solid;
      cursor: pointer;
      background-color: rgba(83, 168, 255, 0.1);
      color: #409EFF;
    }
    .select_multiple {
      ::v-deep .el-select__tags {
        max-height: 80px;
        overflow-y: auto;
        overflow-x: hidden;
      }
    }
  }
  .el-main {
    padding: 0 6px 0;
    .box-card {
      & > ::v-deep .el-card__body {
        height: calc(100% - 33px);
        box-sizing: border-box;
        .box-card-query {
          height: 46px;
          flex-shrink: 0;
          .el-form {
            .el-form-item {
              margin-bottom: 0;
            }
          }
        }
      }
    }
    .table {
      height: calc(100% - 45px);
      ::v-deep .el-input-number {
        input {
          padding: 0 !important;
        }
      }
      ::v-deep .elx-table {
        .elx-body--column.col--ellipsis, .elx-table.elx-editable .elx-body--column, .elx-footer--column.col--ellipsis, .elx-header--column.col--ellipsis {
          height: 70px;
        }
        .elx-body--column.col--ellipsis, .elx-footer--column.col--ellipsis, .elx-header--column.col--ellipsis, .elx-table.elx-editable .elx-body--column {
          max-height: none;
        }
        &.size--mini .elx-body--column.col--ellipsis>.elx-cell, &.size--mini .elx-footer--column.col--ellipsis>.elx-cell, &.size--mini .elx-header--column.col--ellipsis>.elx-cell {
          max-height: none;
        }
      }
    }
     .footer {
      height: 45px;
      display: flex;
      align-items: center;
      margin-top: 6px;
      span {
        width: 50%;
        .text {
          font-size: 20px;
          color: #F56C6C;
          padding: 0 4px;
        }
      }
      div {
        transform: translate(-50%, 0);
      }
    }
  }
}
</style>